var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"color":"#2196f3"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }